// Re-export components from skill-select with type assertion
import * as SkillSelectComponents from 'components/skill-select/components'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ClearIndicator = SkillSelectComponents.ClearIndicator as any
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Control = SkillSelectComponents.Control as any
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Group = SkillSelectComponents.Group as any
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const GroupHeading = SkillSelectComponents.GroupHeading as any
export const IndicatorsContainer =
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  SkillSelectComponents.IndicatorsContainer as any
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Input = SkillSelectComponents.Input as any
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const MenuList = SkillSelectComponents.MenuList as any
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const NoOptionsMessage = SkillSelectComponents.NoOptionsMessage as any
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Placeholder = SkillSelectComponents.Placeholder as any
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ValueContainer = SkillSelectComponents.ValueContainer as any
export const DropdownIndicator = SkillSelectComponents.DropdownIndicator
export const IndicatorSeparator = SkillSelectComponents.IndicatorSeparator

// Only Option component needs custom implementation
export * from './option'
